import { convertToEnglishDigit } from "../../helpers/Functions";
import ApiService from "./ApiService";

class AuthApiService extends ApiService {
  /**
   *
   * @param {string} phone
   * @returns {Promise}
   */
  async login(phone) {
    try {
      const res = await this.axios.post("auth/login", {
        phone: convertToEnglishDigit(phone),
      });
      return res;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }

  /**
   *
   * @param {string} phone
   * @param {string} code
   * @returns {Promise}
   */
  async verify(phone, code) {
    try {
      const res = await this.axios.post("auth/verify", {
        phone: convertToEnglishDigit(phone),
        code: convertToEnglishDigit(code),
      });
      return res;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }

  /**
   *
   * @returns {Promise}
   */
  async logout() {
    const fcmToken = localStorage.getItem("notification-token");

    try {
      const res = await this.axios.post("auth/logout", { fcmToken });
      return res;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }
}

const authApiService = new AuthApiService();
export default authApiService;
